export function getDisplayName(args) {
  return {
    type: 'inspect_dom',
    action: args.action,
    selector: args.selector
  };
}
